<p-dialog [modal]="true" [(visible)]="displayViewApproval" [style]="{width: '60vw'}" [baseZIndex]="10000"
    [focusOnShow]="false" (onHide)="onClose()">
    <ng-template pTemplate="header">
        <div class="p-d-flex p-jc-between" style="width: 100%;">
            <h5>Approval Details</h5>
        </div>
    </ng-template>

    <form #approvalForm="ngForm">
        <div class="card">
            <div class="p-field p-grid p-mb-0">
                <ng-container *ngIf="approvalDetails?.approvalTitle">
                    <div class="p-col-4 p-md-2">
                        <p><strong>Approval Type</strong></p>
                    </div>
                    <div class="p-col-8 p-md-4">
                        <p>{{approvalDetails?.approvalTitle}}</p>
                    </div>
                </ng-container>
                <ng-container *ngIf="approvalDetails?.initiationDate">
                    <div class="p-col-4 p-md-2">
                        <p><strong>Initiation Date</strong></p>
                    </div>
                    <div class="p-col-8 p-md-4">
                        <p>{{approvalDetails?.initiationDate | localDate}}</p>
                    </div>
                </ng-container>
                <ng-container *ngIf="approvalDetails?.senderName">
                    <div class="p-col-4 p-md-2">
                        <p><strong>Sent By</strong></p>
                    </div>
                    <div class="p-col-8 p-md-4">
                        <p>{{approvalDetails?.senderName}}</p>
                    </div>
                </ng-container>
                <ng-container *ngIf="approvalDetails?.approvalType && approvalDetails?.sequenceNumber">
                    <div class="p-col-4 p-md-2">
                        <p><strong>{{ getApprovalTypeLabel(approvalDetails?.approvalType) }}</strong></p>
                    </div>
                    <div class="p-col-8 p-md-4">
                        <p class="approval-popup-link" style="word-break: break-word;"  (click)="navigateToTransactionTypeDetailsPage(approvalDetails?.approvalType, approvalDetails?.sequenceNumber)">
                            {{approvalDetails?.sequenceNumber}}
                        </p>
                    </div>
                </ng-container>                
                <ng-container *ngIf="approvalDetails?.pendingAt?.length; else approvalStatusInfo">
                    <div class="p-col-4 p-md-2">
                      <p><strong>Pending at</strong></p>
                    </div>
                    <div class="p-col-8 p-md-4">
                      <p>{{approvalDetails?.pendingAt}}</p>
                    </div>
                  </ng-container>                
                  <ng-template #approvalStatusInfo>
                    <ng-container *ngIf="approvalDetails?.updatedByName">
                      <div class="p-col-4 p-md-2">
                        <p><strong>{{ approvalDetails?.approvalStatus === ApprovalStatus.Approved ? 'Approved By' : 'Declined By' }}</strong></p>
                      </div>
                      <div class="p-col-8 p-md-4">
                        <p>{{approvalDetails?.updatedByName}}</p>
                      </div>
                    </ng-container>
                  </ng-template>
                <ng-container>
                    <div class="p-col-4 p-md-2">
                        <p><strong>Status</strong></p>
                    </div>
                    <div class="p-col-8 p-md-4">
                        <p>{{approvalDetails?.approvalStatus | approvalStatusPipe }}</p>
                    </div>
                </ng-container>
            </div>
            <div class="p-field p-grid p-mb-0">
                <ng-container *ngIf="approvalDetails?.description">
                    <div class="p-col-4 p-md-2">
                        <p><strong>Description</strong></p>
                    </div>
                    <div class="p-col-8 p-md-10">
                        <p>{{approvalDetails?.description}}</p>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="header">
            <h5>History</h5>
        </div>
        <div class="card">
            <div class="p-grid">
                <div
                    [ngClass]="{'p-col-12': !approvalDetails?.approvalInfo, 'p-col-6 divider':approvalDetails?.approvalInfo}">
                    <ng-container *ngIf="approvalDetails?.approvalHistoryInfoes?.length>0; else noHistory">
                        <ng-container
                            *ngFor="let historyInfo of approvalDetails?.approvalHistoryInfoes; let row = index">

                            <div class="timeline">
                                <div class="timeline-separator ">
                                    <div class="timeline-marker"
                                        [ngStyle]="{'border-color': getStatusStyles(historyInfo?.approvalStatus)?.borderColor}">
                                    </div>
                                    <div class="timeline-connector"
                                        [ngStyle]="{
                                        'background-color': getStatusStyles(historyInfo?.approvalStatus)?.backgroundColor}"></div>
                                </div>
                                <p-card class="comment-card timeline-right">
                                    <div class="approval-card">
                                        <div class="activity-icon p-shadow-3 icon-container"
                                            [pTooltip]="historyInfo?.approvalStatus | approvalStatusPipe"
                                            tooltipPosition="top"
                                            [ngStyle]="{
                                                'background-color': getStatusStyles(historyInfo?.approvalStatus)?.backgroundColor}">
                                            <span
                                                [ngClass]="getStatusStyles(historyInfo?.approvalStatus)?.iconClass"></span>
                                        </div>
                                        <div class="w-100">
                                            <h6 class="p-mb-1">
                                                <span> {{historyInfo?.approvalStatus | approvalStatusPipe}} </span>
                                                <ng-container
                                                    *ngIf="historyInfo?.approvalStatus === ApprovalStatus.Default ||historyInfo?.approvalStatus === ApprovalStatus.Approved || historyInfo?.approvalStatus === ApprovalStatus.Declined || historyInfo?.approvalStatus === ApprovalStatus.PartiallyApproved">
                                                    <span> by </span>
                                                </ng-container>
                                                <ng-container
                                                    *ngIf="historyInfo?.approvalStatus === ApprovalStatus.Queued || historyInfo?.approvalStatus === ApprovalStatus.Pending">
                                                    <span> at </span>
                                                </ng-container>
                                                <ng-container
                                                *ngIf="historyInfo?.approvalStatus === ApprovalStatus.Approved || historyInfo?.approvalStatus === ApprovalStatus.Declined; else approverName">
                                                    <span> {{historyInfo?.approvedByName}}</span>    
                                                </ng-container>
                                                <ng-template #approverName>
                                                    <span>{{ historyInfo?.receiverName }}</span>
                                                  </ng-template>
                                                <ng-container
                                                    *ngIf="historyInfo?.approvalStatus === ApprovalStatus.Approved || historyInfo?.approvalStatus === ApprovalStatus.Declined">
                                                    <span class="created-date">
                                                        {{historyInfo?.approvedDate | localDate}}
                                                    </span>
                                                </ng-container>
                                                <ng-container
                                                *ngIf="historyInfo?.approvalStatus === ApprovalStatus.Default">
                                                <span class="created-date">
                                                    {{historyInfo?.createdDate | localDate}}
                                                </span>
                                            </ng-container>
                                            </h6>
                                            <div class="description-container">
                                                <p class="description-text" [ngClass]="{'collapsed': !isExpanded[row]}">
                                                    {{historyInfo?.description}}

                                                </p>
                                                <span *ngIf="historyInfo?.description?.length>100"> <a class="show-more"
                                                        (click)="toggleDescription(row)">
                                                        {{ isExpanded[row] ? 'Show Less' : 'Show More' }}
                                                    </a></span>
                                            </div>
                                            <ng-container *ngIf="historyInfo?.approvalAttachments?.length>0">
                                                <ng-container *ngFor="let attachmentDetails of historyInfo?.approvalAttachments;let i=index;">
                                                    <ng-container *ngIf="attachmentDetails.statusId === 1">
                                                        <div class="p-fileupload-row">
                                                            <button type="button" pButton icon="fa fa-download"
                                                                (click)="downloadFile(attachmentDetails.displayFileName, attachmentDetails?.attachment?.content, attachmentDetails?.attachment?.id)"
                                                                class="p-button-link p-px-0 p-py-0" label="">
                                                            </button>
                                                            <div
                                                                [ngClass]="{'p-fileupload-link': !!(attachmentDetails?.attachment?.id>0)}">
                                                                <ng-container
                                                                    *ngIf="attachmentDetails?.displayFileName?.length>50 else splitImageName">
                                                                    <div
                                                                        (click)="openFileNewTab(attachmentDetails?.attachment)">
                                                                        {{ attachmentDetails.displayFileName.substring(0, 50)
                                                                        }}...</div>
                                                                </ng-container>
                                                                <ng-template #splitImageName>
                                                                    <div
                                                                        (click)="openFileNewTab(attachmentDetails?.attachment)">
                                                                        {{ attachmentDetails.displayFileName }}</div>
                                                                </ng-template>
                                                            </div>
        
                                                            <div style="width: 100px; max-width: 100px;">{{
                                                                (attachmentDetails.fileSize / 1024).toFixed(2) + ' KB' }}</div>
                                                        </div>
                                                    </ng-container>
                                                </ng-container>
                                            </ng-container>
                                        </div>
                                    </div>
                                </p-card>
                            </div>
                        </ng-container>
                    </ng-container>
                    <ng-template #noHistory>
                        <div class="p-col-6">
                            <p>No approval history available.</p>
                        </div>
                    </ng-template>
                </div>
                <div class="p-col-6" >
                    <ng-container *ngIf="approvalDetails?.approvalInfo">
                        <h6 class="p-mb-1"> Description:</h6>
                        <textarea rows="5" cols="30" pInputTextarea autoResize="autoResize"
                            placeholder="Write some Description..." style="min-height: 100px;"
                            [(ngModel)]="approvalDescription" name="description" #description="ngModel" required
                            maxlength="513"></textarea>
                        <div class="p-grid p-mt-1 p-ml-1 p-error">
                            <small *ngIf="description.errors?.required && (description.dirty || description.touched)">Description is required.</small>
                            <small *ngIf="approvalDescription.length>512">Description cannot exceed 512
                                characters.</small>                                
                        </div>
                        <div class="p-grid p-mt-2">
                            <div class="p-col-12">
                                <label for="upload">Attachments(Max Size 2MB) <i class="pi pi-exclamation-circle"
                                        [escape]="false" [pTooltip]="multiLineTooltip"
                                        tooltipPosition="top"></i></label>

                                <p-fileUpload customUpload="true" class="fupload" previewWidth="100"
                                    chooseLabel="Choose Files" [multiple]="true" [showUploadButton]="false"
                                    [showCancelButton]="false" [disabled]="false"
                                    (onSelect)="uploadAttachments($event.files)">
                                    <ng-template pTemplate="file"></ng-template>
                                    <ng-template pTemplate="content">
                                        <ng-container *ngFor="let attachmentDetails of attachments;let i=index;">
                                            <ng-container *ngIf="attachmentDetails.statusId === 1">
                                                <div class="p-fileupload-row">
                                                    <button type="button" pButton icon="fa fa-download"
                                                        (click)="downloadFile(attachmentDetails.displayFileName, attachmentDetails?.attachment?.content, attachmentDetails?.attachment?.id)"
                                                        class="p-button-link p-px-0 p-py-0" label="">
                                                    </button>
                                                    <div
                                                        [ngClass]="{'p-fileupload-link': !!(attachmentDetails?.attachment?.id>0)}">
                                                        <ng-container
                                                            *ngIf="attachmentDetails?.displayFileName?.length>50 else splitImageName">
                                                            <div
                                                                (click)="openFileNewTab(attachmentDetails?.attachment)">
                                                                {{ attachmentDetails.displayFileName.substring(0, 50)
                                                                }}...</div>
                                                        </ng-container>
                                                        <ng-template #splitImageName>
                                                            <div
                                                                (click)="openFileNewTab(attachmentDetails?.attachment)">
                                                                {{ attachmentDetails.displayFileName }}</div>
                                                        </ng-template>
                                                    </div>

                                                    <div style="width: 100px; max-width: 100px;">{{
                                                        (attachmentDetails.fileSize / 1024).toFixed(2) + ' KB' }}</div>
                                                    <div style="width: 100px; max-width: 100px;" >
                                                        <button icon="pi pi-times" pButton
                                                            (click)="removeAttachment(attachmentDetails,i)"
                                                            type="button"></button>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </ng-container>
                                    </ng-template>
                                </p-fileUpload>

                            </div>
                        </div>
                        <div class="btn-container">
                            <button  pButton pRipple type="button" label="Decline"
                                class="p-button-danger" [disabled]="approvalForm.invalid || approvalDescription?.length>512 || isSubmitting"
                                (click)="handleApprovalStatus(ApprovalStatus.Declined, approvalForm)"></button>
                            <button  pButton pRipple type="button" label="Approve"
                                class="p-button-success" [disabled]="approvalForm.invalid || approvalDescription?.length>512 || isSubmitting"
                                (click)="handleApprovalStatus(ApprovalStatus.Approved, approvalForm)"></button>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </form>
    <!-- <ng-template pTemplate="footer">
        <button pButton (click)="onClose()" label="Cancel" class="p-button-secondary"></button>

    </ng-template> -->
</p-dialog>
<!-- Inventory Overview -->
<app-inventory-module-overview-dialogs
    *ngIf="displayInventoryOverview"
    [displayOverview]="displayInventoryOverview"
    [overviewRefId]="inventoryOverviewRefId"
    [overviewRefNumber]="inventoryOverviewRefNumber"
    [overviewModule]="inventoryOverviewModule"
    (onCancel)="closeViewPopup()">
</app-inventory-module-overview-dialogs>
